<template>
  <v-app class="back">
    <v-container fluid class="doc mt-n1 ml-1">
      <v-row justify="center">
        <v-col class="mt-1" md="12">
          <v-row>
            <v-col md="8">
              <span class="display-1 titulo font-weight-bold">Contas</span>
            </v-col>
            <v-spacer></v-spacer>
            <v-col md="auto">
              <v-btn
                @click="dialog_conta =  true"
                rounded
                color="#283480"
                class="white--text"
                v-if="editModulo"
              >Adicionar nova conta</v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-card flat height="100%" class="borda">
        <!-- LISTAGEM -->
        <v-container fluid>
          <v-row>
            <v-col
              class="mb-n4"
              md="4"
              sm="6"
              cols="12"
              v-for="item in formData"
              :key="item.id_conta"
            >
              <v-card flat outlined class="borda" width="100%">
                <v-card-title class="mt-2 pa-0">
                  <div class="ml-3">
                    <v-icon>{{ item.conta_icone }}</v-icon>
                    <span class="subtitle-1 black--text font-weight-bold">⠀{{ item.conta_nome }}</span>
                    <span class="inativo_conta" v-if="item.conta_status == '0'">(Inativo)</span>
                  </div>
                  <v-spacer></v-spacer>
                  <v-tooltip top color="black" v-if="!editModulo">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on" text>
                        <v-icon>mdi-information-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>
                      Sem autorização para
                      <span class="orange--text">editar</span> ou
                      <span class="red--text">excluir</span>
                    </span>
                  </v-tooltip>
                  <v-menu offset-x v-if="editModulo">
                    <template v-slot:activator="{ on }">
                      <v-btn icon text v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list v-if="!item.conta_fixa && item.conta_status == '0'">
                      <div v-for="(iten, index) in opcoesAtivas" :key="index">
                        <v-list-item @click="menu(iten,item)">
                          <v-icon>{{ iten.icon }}</v-icon>
                          <v-list-item-title>{{ iten.nome }}</v-list-item-title>
                        </v-list-item>
                      </div>
                    </v-list>
                    <v-list v-if="!item.conta_fixa && item.conta_status == '1'">
                      <div v-for="(iten, index) in opcoes" :key="index">
                        <v-list-item @click="menu(iten,item)">
                          <v-icon>{{ iten.icon }}</v-icon>
                          <v-list-item-title>{{ iten.nome }}</v-list-item-title>
                        </v-list-item>
                      </div>
                    </v-list>
                    <v-list v-if="item.conta_fixa && item.conta_status == '0'">
                      <div v-for="(iten, index) in opcoesAtivasFixa" :key="index">
                        <v-list-item @click="menu(iten,item)">
                          <v-icon>{{ iten.icon }}</v-icon>
                          <v-list-item-title>{{ iten.nome }}</v-list-item-title>
                        </v-list-item>
                      </div>
                    </v-list>
                    <v-list v-if="item.conta_fixa && item.conta_status == '1'">
                      <div v-for="(iten, index) in opcoesFixa" :key="index">
                        <v-list-item @click="menu(iten,item)">
                          <v-icon>{{ iten.icon }}</v-icon>
                          <v-list-item-title>{{ iten.nome }}</v-list-item-title>
                        </v-list-item>
                      </div>
                    </v-list>
                  </v-menu>
                </v-card-title>
                <v-card-text class="ma-0 py-0">
                  <v-row class="mt-2">
                    <v-col md="auto">
                      <span>Data saldo inicial:</span>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col md="auto">
                      <span
                        class="black--text subtitle-2"
                      >{{ item.conta_data_saldo_inicial | moment("L" )}}</span>
                    </v-col>
                  </v-row>
                  <v-row class="mt-n5">
                    <v-col md="auto">
                      <span>Saldo Inicial:</span>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col md="auto">
                      <span class="black--text subtitle-2">R$ {{ item.conta_saldo_inicial }}</span>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-container>

    <!-- DIALOG EDITAR -->
    <v-dialog v-model="dialog_edit_conta" persistent max-width="700">
      <v-form ref="form" v-model="valid" @submit.prevent="edit()">
        <v-card flat class="borda">
          <v-card-title class="ma-2">
            Editar conta
            <v-spacer></v-spacer>
            <v-btn icon text @click="close()">
              <v-icon>mdi-close-thick</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-row>
              <v-col cols="9" sm="10" md="10" class="mb-n5">
                <span class="font-weight-bold black--text">Nome</span>
                <v-text-field
                  :rules="requiredRules"
                  v-model="nova_conta.conta_nome"
                  solo
                  dense
                  flat
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="3" sm="2" md="2" class="mb-n5">
                <span class="font-weight-bold black--text">Ícone</span>
                <br />
                <v-btn large @click="dialog_icone = true" icon>
                  <v-icon large>{{ nova_conta.conta_icone }}</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="6" class="mb-n5">
                <span class="font-weight-bold black--text">Saldo inicial</span>
                <money
                  class="input"
                  :rules="requiredRules"
                  v-model.lazy="nova_conta.conta_saldo_inicial"
                  v-bind="moneyFormat"
                ></money>
              </v-col>
              <v-col cols="12" sm="12" md="6" class="mb-n5">
                <span class="font-weight-bold black--text">Data do saldo inicial</span>
                <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      solo
                      flat
                      outlined
                      dense
                      @blur="nova_conta.conta_data_saldo_inicial = parseDate(dateFormatted)"
                      v-model="dateFormatted"
                      append-icon="mdi-calendar"
                      clearable
                      v-mask="data_mask"
                      :rules="requiredRules"
                      v-on="on"
                      @input="menu1 = false"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date"
                    no-title
                    locale="pt-br"
                    scrollable
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="6" class="mb-n5">
                <v-checkbox
                  class="mb-n7 mt-n5"
                  label="Considerar saldo"
                  v-model="nova_conta.conta_saldo_considerar"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row class="mb-4" no-gutters justify="center">
              <v-btn
                class="mr-2"
                rounded
                style="color: #283480 !important"
                outlined
                @click="close()"
              >Cancelar</v-btn>
              <v-btn
                class="ml-2"
                rounded
                style="background-color: #283480  !important; color:#00FFD4  !important"
                @click="edit()"
              >
                <v-icon>mdi-content-save</v-icon>
                <span>Salvar</span>
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- DIALOG CADASTRAR -->
    <v-dialog v-model="dialog_conta" persistent max-width="700">
      <v-form ref="form" v-model="valid" @submit.prevent="save()">
        <v-card flat class="borda">
          <v-card-title class="ma-2">
            Nova conta
            <v-spacer></v-spacer>
            <v-btn icon text @click="close()">
              <v-icon>mdi-close-thick</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="12" md="10" class="mb-n5">
                <span class="font-weight-bold black--text">Nome</span>
                <v-text-field
                  :rules="requiredRules"
                  v-model="nova_conta.conta_nome"
                  solo
                  dense
                  flat
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="2" class="mb-n5">
                <span class="font-weight-bold black--text">Ícone</span>
                <br />
                <v-btn large @click="dialog_icone = true" icon>
                  <v-icon large>{{ nova_conta.conta_icone }}</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="6" class="mb-n5">
                <span class="font-weight-bold black--text">Saldo inicial</span>
                <money
                  class="input"
                  :rules="requiredRules"
                  v-model.lazy="nova_conta.conta_saldo_inicial"
                  v-bind="moneyFormat"
                ></money>
              </v-col>
              <v-col cols="12" sm="12" md="6" class="mb-n5">
                <span class="font-weight-bold black--text">Data do saldo inicial</span>
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      solo
                      flat
                      outlined
                      dense
                      @blur="nova_conta.conta_data_saldo_inicial = parseDate(dateFormatted)"
                      v-model="dateFormatted"
                      append-icon="mdi-calendar"
                      clearable
                      v-mask="data_mask"
                      :rules="requiredRules"
                      v-on="on"
                      @input="menu2 = false"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date"
                    no-title
                    locale="pt-br"
                    scrollable
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="6" class="mb-n5">
                <v-checkbox
                  class="mb-n7 mt-n5"
                  label="Considerar saldo"
                  v-model="nova_conta.conta_saldo_considerar"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row class="mb-4" no-gutters justify="center">
              <v-btn
                class="mr-2"
                rounded
                style="color: #283480 !important"
                outlined
                @click="close()"
              >Cancelar</v-btn>
              <v-btn
                class="ml-2"
                rounded
                style="background-color: #283480  !important; color:#00FFD4  !important"
                @click="save()"
              >
                <v-icon>mdi-content-save</v-icon>
                <span>Salvar</span>
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- DIALOG ICONES -->
    <v-dialog v-model="dialog_icone" persistent width="500px">
      <v-card flat class="borda">
        <v-card-title class="ma-2">
          Selecionar ícone
          <v-spacer></v-spacer>
          <v-btn icon text @click="dialog_icone = false">
            <v-icon>mdi-close-thick</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col>
              <v-btn @click="icone = 0,pegar_icone()" large icon>
                <v-icon large>mdi-bank</v-icon>
              </v-btn>
            </v-col>
            <v-col>
              <v-btn @click="icone = 1,pegar_icone()" large icon>
                <v-icon large>mdi-cash-multiple</v-icon>
              </v-btn>
            </v-col>
            <v-col>
              <v-btn @click="icone = 2,pegar_icone()" large icon>
                <v-icon large>mdi-credit-card</v-icon>
              </v-btn>
            </v-col>
            <v-col>
              <v-btn @click="icone = 3,pegar_icone()" large icon>
                <v-icon large>mdi-safe-square-outline</v-icon>
              </v-btn>
            </v-col>
            <v-col>
              <v-btn @click="icone = 4,pegar_icone()" large icon>
                <v-icon large>mdi-cash-register</v-icon>
              </v-btn>
            </v-col>
            <v-col>
              <v-btn @click="icone = 5,pegar_icone()" large icon>
                <v-icon large>mdi-cash-usd-outline</v-icon>
              </v-btn>
            </v-col>
            <v-col>
              <v-btn @click="icone = 6,pegar_icone()" large icon>
                <v-icon large>mdi-script-text</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- DIALOG EXCLUIR -->
    <v-dialog v-model="dialog_delete" persistent max-width="400">
      <v-card class="borda" flat>
        <v-card-title class="headline">Tem certeza que deseja deletar esta categoria?</v-card-title>
        <v-card-text>Se deletar esta conta ela não poderá ser recuperada!!</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined rounded color="#283480" @click="dialog_delete = false">Cancelar</v-btn>
          <v-btn
            style="background-color: #283480  !important; color:#00FFD4  !important"
            rounded
            @click="deleteItem(), dialog_delete = false"
          >Sim, tenho certeza</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Api from "@/common/api.helper";
export default {
  data: () => ({
    menu1: false,
    menu2: false,
    data_mask: "##/##/####",
    icone: "",
    loading: false,
    moneyFormat: {
      decimal: ",",
      thousands: ".",
      prefix: "R$ ",
      precision: 2,
      masked: false,
    },

    date: new Date().toISOString().substr(0, 10),
    dateFormatted: "",
    dialog_edit_conta: false,
    dialog_conta: false,
    dialog_icone: false,
    dialog_delete: false,
    icones: [
      "mdi-bank",
      "mdi-cash-multiple",
      "mdi-credit-card",
      "mdi-safe-square-outline",
      "mdi-cash-register",
      "mdi-cash-usd-outline",
      "mdi-script-text",
    ],
    opcoesAtivas: [
      { nome: "⠀Editar", icon: "mdi-pencil-outline" },
      { nome: "⠀Ativar", icon: "mdi-transfer-up" },
      { nome: "⠀Excluir", icon: "mdi-delete-outline" },
    ],
    opcoes: [
      { nome: "⠀Editar", icon: "mdi-pencil-outline" },
      { nome: "⠀Inativar", icon: "mdi-transfer-down" },
      { nome: "⠀Excluir", icon: "mdi-delete-outline" },
    ],
    opcoesAtivasFixa: [
      { nome: "⠀Editar", icon: "mdi-pencil-outline" },
      { nome: "⠀Ativar", icon: "mdi-transfer-up" },
    ],
    opcoesFixa: [
      { nome: "⠀Editar", icon: "mdi-pencil-outline" },
      { nome: "⠀Inativar", icon: "mdi-transfer-down" },
    ],
    nova_conta: {
      conta_icone: "mdi-credit-card",
      conta_nome: "",
      conta_saldo_inicial: "",
      conta_data_saldo_inicial: new Date().toISOString().substr(0, 10),
      conta_saldo_considerar: "1",
      conta_status: "1",
      conta_finalizada: "0",
    },
    valid: true,
    requiredRules: [(v) => !!v || "Campo Obrigatório."],
    formData: [],
    editModulo: false,
  }),
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
  },
  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.date);
      this.nova_conta.conta_data_saldo_inicial = this.parseDate(
        this.dateFormatted
      );
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    menu(opcao, item) {
      this.formData.id_conta = item.id_conta;
      if (opcao.nome === "⠀Excluir") {
        this.dialog_delete = true;
      } else if (opcao.nome === "⠀Editar") {
        this.nova_conta.conta_icone = item.conta_icone;
        this.nova_conta.conta_nome = item.conta_nome;
        this.nova_conta.conta_saldo_inicial = item.conta_saldo_inicial;
        this.nova_conta.conta_data_saldo_inicial =
          item.conta_data_saldo_inicial;
        this.date = item.conta_data_saldo_inicial;
        this.nova_conta.conta_saldo_considerar = item.conta_saldo_considerar;
        this.dialog_edit_conta = true;
      } else if (opcao.nome === "⠀Inativar") {
        this.nova_conta.conta_status = "0";
        this.loading = true;
        Api.post(`/contas/status/` + this.formData.id_conta, this.nova_conta)
          .then((response) => {
            if (response) {
              this.loading = false;
            }
            this.loading = false;
            this.$toast.success("Conta inativada com sucesso!");
            this.formData.id_conta = "";
            this.getContas();
          })
          .catch((err) => {
            this.loading = false;
            this.$toast.error("Oops! Ocorreu um erro.");
            throw err;
          });
      } else if (opcao.nome === "⠀Ativar") {
        this.nova_conta.conta_status = "1";
        this.loading = true;
        Api.post(`/contas/status/` + this.formData.id_conta, this.nova_conta)
          .then((response) => {
            if (response) {
              this.loading = false;
            }
            this.loading = false;
            this.$toast.success("Conta ativada com sucesso!");
            this.formData.id_conta = "";
            this.getContas();
          })
          .catch((err) => {
            this.loading = false;
            this.$toast.error("Oops! Ocorreu um erro.");
            throw err;
          });
      }
    },
    pegar_icone() {
      this.nova_conta.conta_icone = this.icones[this.icone];
      this.dialog_icone = false;
    },
    close() {
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
      this.data = new Date().toISOString().substr(0, 10);
      this.dialog_conta = false;
      this.dialog_edit_conta = false;
      this.nova_conta = {
        conta_icone: "mdi-credit-card",
        conta_nome: "",
        conta_saldo_inicial: "",
        conta_data_saldo_inicial: new Date().toISOString().substr(0, 10),
        conta_saldo_considerar: 1,
        conta_status: "1",
        conta_finalizada: "0",
      };
    },
    edit() {
      if (this.$refs.form.validate()) {
        Api.post(`/contas/` + this.formData.id_conta, this.nova_conta)
          .then((response) => {
            this.loading = false;
            if (response) {
              this.loading = false;
            }
            this.$toast.success("Editado com sucesso!");
            this.formData.id_conta = "";
            this.getContas();
            this.close();
          })
          .catch((err) => {
            this.loading = false;
            this.$toast.error("Oops! Ocorreu um erro.");
            throw err;
          });
      }
    },
    getContas() {
      Api.get(`/contas/todas`)
        .then((response) => {
          if (response.data.data) {
            this.formData = response.data.data;
          }
        })
        .catch((err) => {
          throw err;
        });
    },
    deleteItem() {
      Api.delete(`/contas/` + this.formData.id_conta)
        .then((response) => {
          if (!response.data.errors) {
            this.$toast.success("Excluído com sucesso!");
            this.formData.id_conta = "";
            this.getContas();
          } else {
            this.$toast.warning(response.data.errors);
            this.formData.id_conta = "";
          }
        })
        .catch((err) => {
          throw err;
        });
    },
    save() {
      if (this.$refs.form.validate()) {
        Api.post("/contas", this.nova_conta)
          .then((response) => {
            this.loading = false;
            if (response.data.id_conta) {
              this.$toast.success("Cadastrado com sucesso!");
            }
            this.getContas();
            this.$refs.form.resetValidation();
            this.close();
          })
          .catch((err) => {
            this.loading = false;
            this.$toast.error("Oops! Ocorreu um erro.");
            throw err;
          });
      }
    },

    async validaEdicaoModulo() {
      this.editModulo = await Api.validaEdicaoModulo(
        this.$router.currentRoute.path
      );
    },
  },
  created() {
    this.getContas();
    this.validaEdicaoModulo();
  },
};
</script>

<style lang="scss" scoped>
</style>